export enum RseeCategoryErrorEnum {
  DATAS_COMP = "DATAS_COMP",
  RSET = "RSET",
  RSENV = "RSENV",
}
